<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Lista de Empresas</h3>
				<div class="card-tools">		
					<button @click="downloadExcel()" v-can="'add_companies'" class="btn btn-sm btn-outline-success mr-1">
						<i class="fa-solid fa-file-excel"></i> Excel
					</button>				
					<router-link :to="`/companies/form`" v-can="'add_companies'" class="btn btn-sm btn-outline-info">
						<i class="fa fa-plus"></i> Empresa
					</router-link>
				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<label>Buscar :</label>
						<input type="text" class="form-control" v-model="search.name" @keyup="list()" />
					</div>
				</div>
				<br>
				<div class="row">
					<div class="col-md-12">
						<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" @click="search.deactivate = 1" data-toggle="pill" role="tab"
									aria-selected="true">Activas</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="search.deactivate = 2" data-toggle="pill" role="tab"
									aria-selected="false">Archivadas</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-bordered text-center text-sm">
						<thead>
							<tr>
								<th>ID</th>
								<th>Nombre</th>
								<th>R.F.C</th>
								<th>Representante legal</th>
								<th>Opciones</th>
							</tr>
						</thead>
						<tbody v-if="companies">
							<tr v-for="(user, index) in companies.data" :key="index">
								<td>{{ user.id }}</td>
								<td>{{ user.name }}</td>
								<td>{{ user.rfc }}</td>								
								<td>
									<span v-if="user.representative">
										{{ user.representative }}
									</span>
									<span v-else>
										S/N
									</span>
								</td>								
								<td>
									<router-link :to="`/companies/form/${user.id}`" v-can="'edit_companies'" class="btn m-1 btn-outline-primary btn-sm">
										<i class="fas fa-edit "> </i> Editar
									</router-link>

									<button  @click="changeStatus(user)" v-can="'edit_companies'" class="btn m-1 btn-outline-info btn-sm">
										<span  v-if="user.deactivate_at" >
											<i class="fa-solid fa-boxes-packing"></i> Sacar del Archivo
										</span>
										<span v-else>
											<i class="fa-solid fa-box-archive"></i> Archivar	
										</span>
										
									</button>

									<button type="button" @click="deleted(user.id)" v-can="'deleted_companies'" class="btn-outline-danger btn m-1 btn-sm ">
										<i class="fa fa-trash"></i> Eliminar
									</button>

									<button @click="showFilesCompanies(user)" class="btn m-1 btn-sm btn-outline-primary">
										<i class="fa-solid fa-layer-group"></i>
										Archivos
										<span class="badge bg-secondary">
											{{ user.files_count }}
										</span>
									</button>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="5">Sin resultados.</td>
							</tr>
						</tbody>
					</table>
					<pagination v-model="page" :records="companies.total" :per-page="companies.per_page" @paginate="list" />
				</div>				
			</div>
		</div>
		<ModalFilesCompaniesComponent prop_edit="true" />
	</div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import Pagination from 'vue-pagination-2';
import request from '@/services/request'
import ModalFilesCompaniesComponent from '@/components/companies/ModalFilesCompaniesComponent.vue';

export default {
	name: "companies-table",
	components: {
		Pagination,
		ModalFilesCompaniesComponent
	},
	data() {
		return {
			companies: {},
			search: {
				name: '',
				deactivate: 1,
			},
			page: 1
		}
	},
	mounted() {
		this.list();
		this.setHeaderTitle('Empresas');
	},
	created() {
			Event.$on("event-load-companies", () => {
				this.list();
			});
	},
	methods: {
		showFilesCompanies(company) {
			Event.$emit('event-show-addFilesCompanies', company);
		},
		downloadExcel() {
			let data = new URLSearchParams(this.search).toString();			
			let url = this.globalUrlFiles + '/companies/export?'+data;		
			window.open(url, '_blank');
		},
		changeStatus: function (compagnie) {
			let tit = 'Archivar empresa';
			let txt = 'Seguro que quiere archivar la empresa';
			if(compagnie.deactivate_at){
				tit = 'Sacar del archivo';
				txt = 'Seguro que quiere sacar del archivo la empresa';
			}
			
			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callChangeStatus(compagnie.id);
				}
			});
		},
		async callChangeStatus(id) {
			let _endpoint = '/companies_status/' + id;
			try {
				let response = await request.post(_endpoint).then(function (response) { return response;});
				this.list();
				this.successNotification(response.data.message);			
			} catch (error) {
				this.errors = await this.errorNotification(error)
			}
		},
		deleted: function (id) {
			let tit = 'Eliminar empresa';
			let txt = 'Seguro que quiere eliminar la empresa';	

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},
		async callDeleted(id) {
			let _endpoint = '/companies/' + id;
			try {
				let response = await request.destroy(_endpoint).then(function (response) { return response;});
				this.list();
				this.successNotification(response.data.message);			
			} catch (error) {
				this.errors = await this.errorNotification(error)
			}
		},
		showImport(){
			this.$modal.show('example');
		},
		async list(page = 1) {
			let service = request;
			let search = this.search;
			let _endpoint = '/companies';
			try {
				let { data } = await service.list(_endpoint, page, search)
				if (data) {
					this.companies = data;
				}
			} catch (error) {
				console.log(error);
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
	},
	watch: {		
		"search": {
			handler: function () {
				this.list();
			},
			deep: true
		}
	}
}
</script>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
	color: #ffffff;
	background-color: #214d83;
	border-color: #dee2e6 #dee2e6 #fff;
}
</style>
